var styles = {
  "TextFieldContainer": "_TextFieldContainer_10fl4_1",
  "TextFieldSwatch": "_TextFieldSwatch_10fl4_5",
  "SwatchBackground": "_SwatchBackground_10fl4_13"
};

export { styles as default };
